






























import { computed, defineComponent, PropType } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { UploadVaultFile } from "@/types";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import VaultFileItemWithPreview from "./components/VaultFileItemWithPreview.vue";
import { PurchasedFilesMap, SentFilesMap } from "../../types";

export default defineComponent({
  name: "VaultFiles",
  components: { LoadingThumbnail, VaultFileItemWithPreview },
  props: {
    files: { type: Array as PropType<UploadVaultFile[]>, required: true },
    thumbnails: { type: Boolean, default: false },
    purchasedFileMap: { type: Object as PropType<PurchasedFilesMap> },
    sentFileMap: { type: Object as PropType<SentFilesMap> },
    fileClasses: { type: Object as PropType<Record<string, string>> },
    showFilesCaption: { type: Boolean, default: false },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, default: () => [] },
  },
  setup(props) {
    const vaultFiles = computed<UploadVaultFile[]>(() => {
      if (props.thumbnails && props.files.length > 0) {
        const f: UploadVaultFile[] = [];
        while (f.length < 4) {
          props.files.forEach((file: UploadVaultFile) => {
            f.push({ ...file, id: f.length.toString() });
          });
        }
        f.length = 4;
        return f;
      } else return props.files;
    });

    const uploadProgress = (file: UploadVaultFile): number => file?.uploadProgress ?? 100;
    const isFileSent = (uuid: string) => !!props.sentFileMap?.[uuid] ?? false;
    const isFilePurchased = (uuid: string) => !!props.purchasedFileMap?.[uuid] ?? false;

    return {
      vaultFiles,
      uploadProgress,
      isFileSent,
      isFilePurchased,
    };
  },
});
